import { Component, OnInit, Input } from '@angular/core';
import { StorageManagerService } from '../../shared/services/index';
import { FormBuilder, FormGroup, FormArray} from '@angular/forms';
import { BaseAccordionComponent } from '../base-accordion/base-accordion.component';

@Component({
    selector: 'app-submission-device-characteristics-eu',
    templateUrl: './submission-device-characteristics-eu.component.html',
    styleUrls: ['./submission-device-characteristics-eu.component.css'],
    standalone: false
})
export class SubmissionDeviceCharacteristicsEuComponent extends BaseAccordionComponent implements OnInit {

  constructor (public fb: FormBuilder, public storage: StorageManagerService) {

    super(fb, storage);
   }

  ngOnInit() {

    this.dataScope = this.storage.read('dataScope');
    this.applicableRegulation = (this.applicableRegulation || '').toUpperCase();

    this.initializeMainForm();

    this.patchForms();
  }

  initializeMainForm() {

    this.deviceForm = this.fb.group({
      singleUseDevice: ['', { validators: [] }],
      maxNumberOfReuse: ['', { validators: [] }],
      reprocessedSingleUseDevice: ['', { validators: [] }],
      packagedOrLabeledAsSterile: ['', { validators: [] }],
      needSterilizationBeforeUse: ['', { validators: [] }],
      clinicalSizeTypeForm: this.fb.array([this.addClinicalSizeTypeForm()]),
      storageHandlingForm: this.fb.array([this.addStorageHandlingForm()]),
      intoductedToHumandBody: ['', { validators: [] }],
      contactLenses: ['', { validators: [] }],
      brainElectroStimulation: ['', { validators: [] }],
      highIntencityRadiation: ['', { validators: [] }],
      equipmentToDestroyTissue: ['', { validators: [] }],
      intendedForInjection: ['', { validators: [] }],
      combinationProduct: ['', { validators: [] }],
      deviceOrIvdReagents: ['', { validators: [] }],
      kit: ['', { validators: [] }],
      consumablesOrEquipment: ['', { validators: [] }],
      sterilizationMethodDescription: ['', {Validators: []}],
      sterilizationMethodsForm: this.fb.array([this.addSterilizationMethodsForm()]),
      clinicalSizesDescription: ['', { validators: [] }],
      specialStorageHandlingCondition: ['', { validators: [] }],
      storageCondition: ['', { validators: [] }],
      distributionAndHandlingCondition: ['', { validators: [] }],
      haveLimitedNoReuses:  ['', { validators: [] }]
    });

    // Watch changes on the entire deviceForm
    this.deviceForm.valueChanges.subscribe(data => {
      this.logValidationErrors(this.deviceForm);
  });
  }

  addSterilizationMethodsForm(): FormGroup {
    return this.fb.group({
      value: ['', { validators: [] }]
    });
  }

  get sterilizationMethodsForm(): FormGroup {
    return <FormGroup>this.deviceForm.get('sterilizationMethodsForm');
  }

  get clinicalSizeTypeForm(): FormGroup {
    return <FormGroup>this.deviceForm.get('clinicalSizeTypeForm');
  }

  get storageHandlingForm(): FormGroup {
    return <FormGroup>this.deviceForm.get('storageHandlingForm');
  }

  addClinicalSizeTypeForm(): FormGroup {

    return this.fb.group({
      sizeType: ['', { validators: [] }],
      sizeTypeDescs:  [this.fb.array([])],
      sizeValue: ['', { validators: [] }],
      sizeMinValue: ['', { validators: [] }],
      sizeMaxValue: ['', { validators: [] }],
      sizeUnit: ['', { validators: [] }],
      sizeUnitDescs:  [this.fb.array([])],
      clinicalSizeText: ['', { validators: [] }]
    });
  }

  addStorageHandlingForm(): FormGroup {

    return this.fb.group({
      storageHandlingCondition: ['', { validators: [] }],
      valueLow: ['', { validators: [] }],
      valueHigh: ['', { validators: [] }],
      unit: ['', { validators: [] }],
      storageHandlingComments: [this.fb.array([])]
    });
  }

  patchForms() {
    this.deviceForm.patchValue({

      singleUseDevice: this.displayItemData('Single Use Device?'),
      maxNumberOfReuse: this.displayItemData('Maximum Number of Reuse'),
      reprocessedSingleUseDevice: this.displayItemData('Reprocessed Single Use Device?'),
      packagedOrLabeledAsSterile: this.displayItemData('Packaged or Labeled as Sterile?'),
      needSterilizationBeforeUse: this.displayItemData('Need Sterilization Before Use?'),
      intoductedToHumandBody: this.displayItemData('Intended to be Totally or Partially Introduced into the Human Body?'),
      contactLenses: this.displayItemData('Contact Lenses?'),
      brainElectroStimulation: this.displayItemData('Brain Electrostimulation?'),
      highIntencityRadiation: this.displayItemData('High Intensity Electromagnetic Radiation?'),
      equipmentToDestroyTissue: this.displayItemData('Equipment to Reduce, Remove or Destroy Adipose Tissue?'),
      intendedForInjection: this.displayItemData('Intended for Filling by Injection?'),
      combinationProduct: this.displayItemData('Combination Product?'),
      deviceOrIvdReagents: this.displayItemData('Device or IVD Reagents?'),
      kit: this.displayItemData('Kit?'),
      consumablesOrEquipment: this.displayItemData('Consumables or Equipment?'),
      sterilizationMethodDescription: this.displayItemData('Sterilization Method Description'),
      clinicalSizesDescription: this.displayItemData('Clinical Size Type and Measurement Description'),

      specialStorageHandlingCondition: this.displayItemData('Special Storage and Handling Condition'),
      storageCondition: this.displayItemData('Storage Condition'),
      distributionAndHandlingCondition: this.displayItemData('Distribution and Handling Condition'),
      haveLimitedNoReuses:  this.displayItemData('Have a limited number of reuses?')
    });

    this.deviceForm.setControl('clinicalSizeTypeForm', this.setClinicalSizeTypeForm());
    this.deviceForm.setControl('storageHandlingForm', this.setStorageHandlingForm());
    this.deviceForm.setControl('sterilizationMethodsForm', this.setSterilizationMethodsForm());
  }

  setSterilizationMethodsForm(): FormArray {

    const formArray = new FormArray([]);

    let methods: any;

    methods = this.displayItemData('Sterilization Method(s)');

    if (methods && methods.length) {
        methods.forEach(c => {
          formArray.push(

                this.fb.group({
                  value: c[(this.getMapInnerPathName('Sterilization Method Value'))[0]]
                })
            );
        });
    }

    return formArray;
  }

  setClinicalSizeTypeForm(): FormArray {

    const formArray = new FormArray([]);

    let types: any;

    types = this.displayItemData('Clinical Size Type(s)');

    if (types && types.length > 0) {
        types.forEach((c, i) => {
          formArray.push(

                this.fb.group({
                  sizeType: c[(this.getMapInnerPathName('Clinical Size Type'))[0]],
                  sizeTypeDescs: this.addClinicalTypeDescriptions(c[(this.getMapInnerPathName('Type Descriptions'))[0]]),
                  sizeValue: c[(this.getMapInnerPathName('Clinical Size Value'))[0]],
                  sizeMinValue: c[(this.getMapInnerPathName('Clinical Size Range - Minimum Value'))[0]],
                  sizeMaxValue: c[(this.getMapInnerPathName('Clinical Size Range - Maximum Value'))[0]],
                  sizeUnit: c[(this.getMapInnerPathName('Clinical Size Unit'))[0]],
                  sizeUnitDescs: this.addClinicalUnitDescriptions(c[(this.getMapInnerPathName('Unit Descriptions'))[0]]),
                  clinicalSizeText: c[(this.getMapInnerPathName('Clinical Size Text'))[0]]
                })
            );
        });
    }

    return formArray;
  }

  addClinicalTypeDescriptions(descs: any): any {

    const arr = [];
    const lqvPairs = descs?.languageQualifiedValue;

    if (lqvPairs && lqvPairs.length) {

      lqvPairs.forEach(lqv => {
        arr.push(

          this.fb.group({
            value: lqv[(this.getMapInnerPathName('Type Descriptions LQV Value'))[0]],
            language: lqv[(this.getMapInnerPathName('Type Descriptions LQV Language'))[0]]
              })
          );
      });
    }

    return this.fb.array(arr);
  }

  addClinicalUnitDescriptions(descs: any): any {
    const arr = [];
    const lqvPairs = descs?.languageQualifiedValue;

    if (lqvPairs && lqvPairs.length) {

      lqvPairs.forEach(lqv => {
        arr.push(

          this.fb.group({
            value: lqv[(this.getMapInnerPathName('Unit Descriptions LQV Value'))[0]],
            language: lqv[(this.getMapInnerPathName('Unit Descriptions LQV Language'))[0]]
              })
          );
      });
    }

    return this.fb.array(arr);
  }

setStorageHandlingForm(): FormArray {

  const formArray = new FormArray([]);

  let conditions: any;
  let comments: any;
  let lqv: any;

  conditions = this.displayItemData('Storage and Handling Conditions');


if (conditions && conditions.length > 0) {
  conditions.forEach((c, i) => {

    comments = c[(this.getMapInnerPathName('Storage and Handling Conditions Comments'))[0]];

    if (comments) {

      lqv = comments[(this.getMapInnerPathName('Storage and Handling Conditions Comments LQV'))[0]];
    } else {

      lqv = [];
    }

    formArray.push(

      this.fb.group({

        storageHandlingCondition: c[(this.getMapInnerPathName('Storage and Handling Conditions Value'))[0]],
        valueLow: c[(this.getMapInnerPathName('Storage and Handling Low Value'))[0]],
        valueHigh: c[(this.getMapInnerPathName('Storage and Handling High Value'))[0]],
        unit: c[(this.getMapInnerPathName('Storage and Handling Unit'))[0]],
        storageHandlingComments:  this.addStorageComments(lqv)
      }));
   });
  }

  return formArray;
  }

  addStorageComments(lqv: any): FormArray {

    const arr = [];

    if (lqv && lqv.length > 0) {

      lqv.forEach(element => {
        arr.push(

          this.fb.group({
            comments: element[(this.getMapInnerPathName('Storage Comments LQV Value'))[0]],
            languageQualifier: element[(this.getMapInnerPathName('Storage Comments LQV Language'))[0]]
              })
          );
      });
    }

    return this.fb.array(arr);
  }
}

